/**
 * Sidebar Component
 * Module 07 - Dashboard UI
 * 
 * Desktop navigation sidebar with modern, sleek design
 */

import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Box, Code, Settings } from 'lucide-react';
import { cn } from '../../utils/cn';

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: Home },
  { name: 'Models', href: '/models', icon: Box },
  { name: 'Embeds', href: '/embeds', icon: Code },
  { name: 'Settings', href: '/settings', icon: Settings },
];

const Sidebar: React.FC = () => {
  return (
    <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
      {/* Logo/Brand */}
      <div className="flex h-16 shrink-0 items-center">
        <h1 className="text-xl font-bold text-primary-600">Navigation</h1>
      </div>
      
      {/* Navigation */}
      <nav className="flex flex-1 flex-col">
        <ul role="list" className="flex flex-1 flex-col gap-y-7">
          <li>
            <ul role="list" className="-mx-2 space-y-1">
              {navigation.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    className={({ isActive }) =>
                      cn(
                        'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors duration-200',
                        isActive
                          ? 'bg-primary-50 text-primary-600'
                          : 'text-gray-700 hover:text-primary-600 hover:bg-gray-50'
                      )
                    }
                  >
                    {({ isActive }) => (
                      <>
                        <item.icon
                          className={cn(
                            'h-6 w-6 shrink-0 transition-colors duration-200',
                            isActive ? 'text-primary-600' : 'text-gray-400 group-hover:text-primary-600'
                          )}
                          aria-hidden="true"
                        />
                        {item.name}
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
